import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    AuthService,
    DataSources,
    EmployeesClient, PermissionType,
    ProfileAgencyDto,
    UpdateProfileAgencyCommand
} from '@services';
import { DxTagBoxModule } from 'devextreme-angular';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import notify from 'devextreme/ui/notify';

@Component({
    selector: 'app-agency-details',
    templateUrl: './agency-details.component.html',
    standalone: true,
    imports: [
        CommonModule,
        DxTagBoxModule
    ]
})
export class AgencyDetailsComponent implements OnInit {
    @Input() userId: string;
    @Input() forceReadOnly = false;
    @Output() isDataChanged = new EventEmitter<boolean>();

    profileDetails: ProfileAgencyDto;
    protected authService = inject(AuthService);
    private employeesClient = inject(EmployeesClient);
    private dataSources = inject(DataSources);

    protected agencyDataSource = this.dataSources.agencyOptions();

    ngOnInit(): void {
        this.loadData();
    }

    loadData() {
        if (!this.userId) return;
        this.employeesClient.getProfileAgency(this.userId).subscribe({
            next: (data) => {
                this.profileDetails = data;
            },
            error: () => notify('Failed to load agency details', 'error', 3000)
        });
    }

    public save(): Observable<void> {
        if (this.isReadOnly) return of(void 0);

        const command = new UpdateProfileAgencyCommand({
            userId: this.userId,
            agencyIds: this.profileDetails.agencyIds
        });

        return this.employeesClient.updateProfileAgency(command).pipe(
            catchError((err) => {
                const errors = err?.response?.errors || [{ message: 'Failed to update agency details' }];
                errors.forEach((errMsg: any) => {
                    notify({
                        message: errMsg.message || errMsg,
                        type: "error",
                        displayTime: 5000,
                    }, {
                        position: "bottom right",
                        direction: "up-push"
                    });
                });
                return throwError(() => err);
            })
        );
    }

    onFieldChange(e: { event?: Event }) {
        // Reloading after Cancel replaces the value programmatically; that is not an edit.
        if (!e.event) return;

        this.isDataChanged.emit(true);
    }

    get isReadOnly(): boolean {
        return this.forceReadOnly || !this.authService.canEditProfileSection(this.userId, PermissionType.UserAgencyDetailsOwn, PermissionType.UserAgencyDetailsOthers);
    }
}
